module.exports = __webpack_public_path__ + "fonts/f9efd93.otf";